import Layout from "../../components/Layout";
import AdminCollectionTable, { formatMoney, formatShortDate } from "../../components/AdminCollectionTable";

const COLUMNS = [
  // Order # — try both BCOrder.id and BCOrder._id (production may use either)
  {
    key: "order_no",
    label: "Order #",
    path: "BCOrder",
    sortable: true,
    sortPath: "BCOrder._id",
    formatter: (bc) => {
      if (!bc || typeof bc !== "object") return "—";
      const v = bc.id ?? bc._id;
      return v === null || v === undefined || v === "" ? "—" : String(v);
    },
  },
  // Display uses the human-readable date string; sort by the ISODate `TMOrder.dt_date_created` for correct chronological order
  { key: "order_date",     label: "Order Date",      path: "BCOrder.date_created",                   sortable: true, sortPath: "TMOrder.dt_date_created", formatter: formatShortDate },
  { key: "status",         label: "Status",          path: "BCOrder.status",                         sortable: true, sortPath: "BCOrder.status" },
  { key: "vip_level",      label: "VIP Level",       path: "TMOrder.VIPLevel",                       sortable: true, sortPath: "TMOrder.VIPLevel" },
  { key: "supplier_name",  label: "Supplier Name",   path: "TMOrder.SupplierName",                   sortable: true, sortPath: "TMOrder.SupplierName" },
  { key: "first_name",     label: "First Name",      path: "BCOrder.billing_address.first_name",     sortable: true, sortPath: "BCOrder.billing_address.first_name" },
  { key: "last_name",      label: "Last Name",       path: "BCOrder.billing_address.last_name",      sortable: true, sortPath: "BCOrder.billing_address.last_name" },
  { key: "phone",          label: "Phone",           path: "BCOrder.billing_address.phone",          sortable: false },
  { key: "postcode",       label: "Postcode",        path: "BCOrder.billing_address.zip",            sortable: true, sortPath: "BCOrder.billing_address.zip" },
  { key: "customer_price", label: "Customer Price",  path: "BCOrder.total_inc_tax",                  sortable: false, formatter: formatMoney },
  { key: "supplier_cost",  label: "Supplier Cost",   path: "TMOrder.SupplierTotalIncVAT",            sortable: true, sortPath: "TMOrder.SupplierTotalIncVAT", formatter: formatMoney },
];

export default function OrderManagement() {
  return (
    <Layout>
      <AdminCollectionTable
        collectionName="orders"
        title="Orders"
        subtitle="Full List of Orders"
        columns={COLUMNS}
      />
    </Layout>
  );
}
